module.exports = __webpack_public_path__ + "static/media/Citi.1ea7d58b.jpg";